/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type { IntlService } from "ember-intl";
import journalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import OxygeneSaturationDeclaredJournalEvent from "parog-web/models/oxygene-saturation-declared-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export default class OxygeneSaturationEditionFormComponent extends journalEventBasedComponent {
  @service declare session: SemeiaSessionService;
  @service declare intl: IntlService;

  static forcDisplayName = "Saturation en oxygène (SpO2)";
  static fullComponentId = "oxygene-saturation/edition-form";

  get validations() {
    return this.journalEventClass.validations(this.intl);
  }

  static journalEventClass = OxygeneSaturationDeclaredJournalEvent;
  journalEventProperties = ["occurredAt", "comments", "spo2"];

  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) model.occurredAt = new Date();
    return model;
  }

  get toastMessage() {
    return this.session.patient
      ? {
          message: "Votre mesure a bien été prise en compte",
          title: "Saturation en oxygène"
        }
      : super.toastMessage;
  }
}
